import React from 'react';

const PlatformSpecIframe: React.FC = () => {
  return (
    <div className="w-full h-screen">
      <iframe
        src="/specification/index.html"
        title="Platform Specification"
        className="w-full h-full border-0"
      />
    </div>
  );
};

export default PlatformSpecIframe;